export const fromPage = (state) => state.fromPage;
export const comesFromLoginPage = (state) => state.fromPage === 'login';
export const comesFromForgotPage = (state) => state.fromPage === 'forgot';

export const flowType = (state) => state.flowType;

export const token = (state) => state.token;

export const verificationReceiver = (state) => state.verificationReceiver;

export const rememberMe = (state) => state.rememberMe;

export const email = (state) => state.email;

export const accountDetails = (state) => state.accountDetails;

export const hasPhoneNumber = (state) => state.verificationInfo.hasPhoneNumber;
export const hasEmailAddress = (state) => state.verificationInfo.hasEmailAddress;

export const hasIdinFailed = (state) => state.hasIdinFailed;

export const idinFailureMessage = (state) => state.idinFailureMessage;
export const hasIdinFailureInstructions = (state) => state.hasIdinFailureInstructions;

export const isVerificationCodeNeeded = (state) => state.isVerificationCodeNeeded;
export const isLoggingOff = (state) => state.isLoggingOff;

export const idinBankOptions = (state) => state.idinBankOptions;
export const bankOptionsValue = (state) => state.bankOptions;

export const isAccountTemporaryBlocked = (state) => state.isAccountTemporaryBlocked;
